import styled, { css } from 'styled-components'

export const Asset = styled.div`
  ${({ theme }) => css`
    &[data-size='tiny'] {
      --size: 6rem;
    }

    &[data-size='small'] {
      --size: 8rem;
    }

    &[data-size='medium'] {
      --size: 12rem;
    }

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: var(--size);
    min-width: var(--size);
    max-width: var(--size);
    max-height: var(--size);
    margin-right: ${theme.spacings.xxxsmall};
    border: 0.25rem solid ${theme.colors.light};

    background-color: ${theme.colors.light};

    cursor: zoom-in;

    .without-video {
      display: flex;
      justify-content: center;
      align-items: center;

      width: var(--size);
      height: var(--size);

      background-color: ${theme.colors.light};
      color: ${theme.colors.primaryLighten30};
    }

    video {
      max-width: 1em;
      max-height: 1em;
    }
  `}
`
